module.exports = __webpack_public_path__ + "static/media/cash_roi.373ee952.png";